/**
 * Get available Distribution Status transitions for current Status
 *
 * @param current - current `status` and `distributionStatus`
 * @param updated - updated `status` - will affect what changes are allowed for `distributionStatus`
 *
 * @returns {Object} - allowed status transitions
 * @returns {string[]} return.allowed - valid statuses to transition to, covers corrective actions
 * @returns {string[]} return.recommended - valid statuses to transition to, covers preferred natural flow scenario
 */
export function getAccountBadgeValidDistributionStatusChanges(current, updated) {
    const invalidStatuses = ['expired', 'revoked', 'reissueNeeded'];
    if (updated && invalidStatuses.includes(updated.status)) {
        return {
            recommended: [],
            allowed: [],
        };
    }
    if (current.distributionStatus === 'not-printed') {
        return {
            recommended: ['processing'],
            allowed: ['processing', 'printed', 'distributed'],
        };
    }
    if (current.distributionStatus === 'processing') {
        return {
            recommended: ['printed'],
            allowed: ['not-printed', 'printed', 'distributed'],
        };
    }
    if (current.distributionStatus === 'printed') {
        return {
            recommended: ['distributed'],
            allowed: ['not-printed', 'processing', 'distributed'],
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (current.distributionStatus === 'distributed') {
        return {
            recommended: [],
            allowed: ['not-printed', 'processing', 'printed'],
        };
    }
    // unnecessary by ts/eslint, but plain string might sneak in bypassing the types
    return {
        recommended: [],
        allowed: [],
    };
}
